<div class="background-image-signin">
  <div class="signin-page-wrapper">
    <div class="signin-bloc">
      <img [src]="logoOf"class="login-image"/>
      <h5 class="small-margin">Bienvenue <br />sur votre Espace Intervenant</h5>      
      <ags-connexion
        [renewPopup]="true"
        [landingRoute]="goToRoute"
        [changePasswordPopupMode]="changePasswordPopupMode"
        (changePasswordPopup)="changePasswordPopup($event)"
        (renewEmit)="dialogOpened = true"
        [accountCreation]="false"
      ></ags-connexion>
    </div>
  </div>

  <div class="bandeau-argalis">
    <div class="version">v{{version}}</div>
    <div class="info">
      Votre Extranet formateur est développé par
      <a href="http://argalis.fr/">Argalis</a>
    </div>
  </div>

  <kendo-window
    title="Récupérer le mot de passe"
    *ngIf="dialogOpened"
    (close)="dialogOpened = false"
    [minWidth]="250"
    [width]="650"
    [resizable]="false"
    [top]="300"
  >
    <ags-renew-password [popupMode]="false" (popupLeave)="dialogOpened = false"></ags-renew-password>
  </kendo-window>

  <kendo-window *ngIf="userConnected && userConnected.password_renew" [width]="450" [top]="300" [resizable]="false">
    <kendo-window-titlebar>
      Modifier le mot de passe
    </kendo-window-titlebar>
    <ags-change-password
      (passwordChangeReponse)="changePasswordReponse($event)"
      [user]="userConnected"
      [checkStrongPassword]="true"
    ></ags-change-password>
  </kendo-window>
</div>
